import { useContext } from "react";
import { MovableColumnContext } from "../context";

export const useMovableColumn = () => useContext(MovableColumnContext);
